import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useClubHttp } from '@/core/api/clubs'
import { Club, ClubPayload } from '@/core/models/club'

export type ClubCollection = {
    data: Array<Club>,
    meta?: MetaPayload,
    links?: any
}

const state: ClubCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const clubCollection: Module<ClubCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ClubCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ClubPayload) => {
                state.data.push(new Club(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useClubHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ClubCollection): ClubCollection => {
            return state
        }
    }
}
